import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { Patterns } from 'src/app/core/resources/patterns';
import { Utils } from 'src/app/core/resources/utils';
import { AuthService } from 'src/app/core/services/authentication.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { LegalTermsService } from 'src/app/modules/administration/legal-terms/legal-terms.service';
import { VehiclesService } from 'src/app/modules/administration/vehicles/list-vehicles.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-request-terms',
  templateUrl: './request-terms.component.html',
  styleUrls: ['./request-terms.component.scss']
})
export class RequestTermsComponent implements OnInit {
  private isUniquePhone: AsyncValidatorFn = (control: AbstractControl): Promise<ValidationErrors | null> => {
    return new Promise<ValidationErrors | null>((resolve) => {
      const phone = control.value;
      if (this.patterns.CELLPHONE.test(phone)) {
        this.vehiclesService
          .getUsersByPhone(phone)
          .subscribe(
            (result: any) => {
              const isTheSame = result && result.information && result.information.document ?
                this.data.document == result && result.information && result.information.document : false;
              if (!!result && !isTheSame)
                resolve({ 'duplicatedPhone': 'El número de celular ya corresponde a otra persona' })
              else resolve(null);
            }
          )
      }
    });
  };

  form = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.pattern(this.patterns.ALPHANUMERIC)
    ]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(this.patterns.CELLPHONE.source)
    ], [
      this.isUniquePhone
    ])
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { document: string, isDriverCreationEdition: boolean },
    public ref: MatDialogRef<RequestTermsComponent>,
    private vehiclesService: VehiclesService,
    private patterns: Patterns,
    private termsAndConditionsService: LegalTermsService,
    public utils: Utils,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private authService: AuthService
  ) { }

  ngOnInit() {
  }

  onSubmit(): void {
    try {
      if (this.form.invalid) return this.snackBarService.openSnackBar('Por favor, complete todos los campos requeridos.', undefined, 'alert');
      const phone: string = this.form.get('phone').value.slice(-10);
      this.spinner.show();
      this.termsAndConditionsService
        .requestTermsAndPoliciesAcceptance(
          this.data.document,
          this.form.get('name').value,
          `57${phone}`,
          this.authService.getCompanySaaS().companyId,
          this.authService.getCompanySaaS().name
        )
        .subscribe((result) => {
          this.spinner.hide();
          this.ref.close(result);
        },
          (error) => {
            this.spinner.hide();
            this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
          }
        )
    } catch (error) {
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    }
  }

  copyDriverRegistration() {
    navigator.clipboard.writeText(this.termsAndConditionsService.getDriverRegistrationUrl(this.authService.getCompanySaaS().companyId));
    this.snackBarService.openSnackBar('Enlace de registro copiado al portapapeles');
  }

  sendMessageToWhatsapp() {
    const phone: string = this.utils.clone(this.form.get('phone').value).slice(-10);
    const name = this.form.get('name').value;
    const message = this.termsAndConditionsService.getSMSMessage(name, this.authService.getCompanySaaS().name, this.authService.getCompanySaaS().companyId);
    const wppLink = `https://wa.me/57${phone}?text=${encodeURIComponent(message)}`;
    window.open(wppLink, '_blank');
  }

  close() {
    this.ref.close(null);
  }

  get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany().companyId === environment.rootNit;
  }
}
